/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NodataReturnOrderResVo } from './NodataReturnOrderResVo';
import {
    NodataReturnOrderResVoFromJSON,
    NodataReturnOrderResVoFromJSONTyped,
    NodataReturnOrderResVoToJSON,
    NodataReturnOrderResVoToJSONTyped,
} from './NodataReturnOrderResVo';

/**
 * 
 * @export
 * @interface ResponseNodataReturnOrderResVo
 */
export interface ResponseNodataReturnOrderResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseNodataReturnOrderResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseNodataReturnOrderResVo
     */
    message?: string;
    /**
     * 
     * @type {NodataReturnOrderResVo}
     * @memberof ResponseNodataReturnOrderResVo
     */
    data?: NodataReturnOrderResVo;
}

/**
 * Check if a given object implements the ResponseNodataReturnOrderResVo interface.
 */
export function instanceOfResponseNodataReturnOrderResVo(value: object): value is ResponseNodataReturnOrderResVo {
    return true;
}

export function ResponseNodataReturnOrderResVoFromJSON(json: any): ResponseNodataReturnOrderResVo {
    return ResponseNodataReturnOrderResVoFromJSONTyped(json, false);
}

export function ResponseNodataReturnOrderResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseNodataReturnOrderResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : NodataReturnOrderResVoFromJSON(json['data']),
    };
}

export function ResponseNodataReturnOrderResVoToJSON(json: any): ResponseNodataReturnOrderResVo {
    return ResponseNodataReturnOrderResVoToJSONTyped(json, false);
}

export function ResponseNodataReturnOrderResVoToJSONTyped(value?: ResponseNodataReturnOrderResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': NodataReturnOrderResVoToJSON(value['data']),
    };
}

